var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHammer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15L30.5745 26.127C31.809 27.357 31.809 29.349 30.5745 30.5775C29.9814 31.1674 29.179 31.4985 28.3425 31.4985C27.506 31.4985 26.7036 31.1674 26.1105 30.5775L15 19.5",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5L15 19.5",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15L13.5 9",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 31.5H15",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1893 23.6895L4.81027 18.3105C4.52907 18.0292 4.37109 17.6478 4.37109 17.25C4.37109 16.8523 4.52907 16.4708 4.81027 16.1895L8.24977 12.75L8.99977 13.5L13.4998 9.00002L12.7498 8.25002L16.1893 4.81052C16.4706 4.52931 16.852 4.37134 17.2498 4.37134C17.6475 4.37134 18.029 4.52931 18.3103 4.81052L23.6893 10.1895C23.9705 10.4708 24.1285 10.8523 24.1285 11.25C24.1285 11.6478 23.9705 12.0292 23.6893 12.3105L20.2498 15.75L19.4998 15L14.9998 19.5L15.7498 20.25L12.3103 23.6895C12.029 23.9707 11.6475 24.1287 11.2498 24.1287C10.852 24.1287 10.4706 23.9707 10.1893 23.6895Z",
    stroke: "#173058",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.430d622793274b282eafee0b67179c95.svg";
export { ForwardRef as ReactComponent };